import React from 'react';
import { CheckIcon, ShieldCheckIcon, ClockIcon, ZapIcon } from 'lucide-react';
import { BuyButton } from './BuyButton';
import { CountdownTimer } from './CountdownTimer';
const includes = ['6 módulos completos (~360 páginas)', 'BONO 1 — Kit de Plantillas Clínicas', 'BONO 2 — Vademécum de 50 Drogas', 'BONO 3 — Banco de 50 Preguntas', 'BONO 4 — Mapa Mental de DDx', 'BONO 5 — Planificador de 90 Días', 'BONO 6 — Guía de Intoxicaciones', 'Acceso inmediato + descarga PDF'];
export function FinalOffer() {
  return <section id="comprar" className="w-full py-12 px-4 bg-gradient-to-b from-green-50 to-sky-50 scroll-mt-4" data-id="element-88">
      <div className="max-w-2xl mx-auto" data-id="element-89">
        <div className="text-center mb-5" data-id="element-90">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-100 text-yellow-800 font-bold text-xs mb-3" data-id="element-91">
            <ZapIcon className="w-3.5 h-3.5" data-id="element-92" /> OFERTA POR TIEMPO LIMITADO
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold leading-tight text-slate-900" data-id="element-93">
            Llevate todo el sistema hoy
          </h2>
          <p className="mt-2 text-slate-600 max-w-xl mx-auto text-sm sm:text-base" data-id="element-94">
            Bonos incluidos{' '}
            <strong className="text-green-700" data-id="element-95">gratis solo por hoy</strong>.
          </p>
        </div>

        <div className="my-5" data-id="element-96">
          <p className="text-center text-xs font-bold text-slate-500 mb-2 flex items-center justify-center gap-1.5" data-id="element-97">
            <ClockIcon className="w-3.5 h-3.5" data-id="element-98" /> LA OFERTA TERMINA EN:
          </p>
          <CountdownTimer data-id="element-99" />
        </div>

        <div className="bg-white text-slate-900 rounded-2xl shadow-xl shadow-green-100 border border-green-100 overflow-hidden" data-id="element-100">
          <div className="p-5 sm:p-7" data-id="element-101">
            <h3 className="font-extrabold text-base sm:text-lg text-center text-slate-900" data-id="element-102">
              Esto es lo que te llevás:
            </h3>
            <ul className="mt-4 grid sm:grid-cols-2 gap-x-4 gap-y-1.5" data-id="element-103">
              {includes.map((i, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-104">
                  <CheckIcon className="w-4 h-4 text-green-600 flex-shrink-0 mt-1" data-id="element-105" />
                  <span className="text-sm font-medium" data-id="element-106">{i}</span>
                </li>)}
            </ul>

            <div className="mt-5 text-center border-t border-slate-100 pt-4" data-id="element-107">
              <div className="flex items-baseline justify-center gap-3 flex-wrap" data-id="element-108">
                <span className="text-lg font-semibold text-slate-400 line-through" data-id="element-109">
                  $52.690
                </span>
                <span className="text-4xl sm:text-5xl font-extrabold text-green-700 tracking-tight" data-id="element-110">
                  $19.899
                </span>
              </div>
              <p className="text-xs text-slate-500 mt-1" data-id="element-111">
                Pago único · Acceso de por vida
              </p>

              <div className="mt-4" data-id="element-112">
                <BuyButton label="QUIERO MI ACCESO AHORA" direct pulse className="w-full text-base sm:text-lg py-4" data-id="element-113" />
              </div>

              <div className="mt-3 flex flex-wrap justify-center items-center gap-3 text-xs text-slate-600" data-id="element-114">
                <span className="inline-flex items-center gap-1.5" data-id="element-115">
                  <ShieldCheckIcon className="w-3.5 h-3.5 text-green-600" data-id="element-116" />{' '}
                  Pago 100% seguro
                </span>
                <span className="inline-flex items-center gap-1.5" data-id="element-117">
                  <ZapIcon className="w-3.5 h-3.5 text-green-600" data-id="element-118" /> Descarga
                  inmediata
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}